'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import Image from 'next/image';

import { MedprevOnlineScheduleButton } from './buttons/medprev-online-schedule-button.component';
import { SearchSectionBoxButtons } from './common/search-section-box-buttons.component';
import { SearchSectionSubtitle } from './titles/search-section-subtitle.component';
import { SearchSectionTitle } from './titles/search-section-title.component';

import onePersonMobile from '@/app/(main)/(pages)/_components/search-section/assets/search-section-one-person-mobile.png';
import onePerson from '@/app/(main)/(pages)/_components/search-section/assets/search-section-one-person.png';
import persons from '@/app/(main)/(pages)/_components/search-section/assets/search-section-persons.png';
import { ContentContainer } from '@/components/ui/content-container.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const SearchSectionDefault = () => {
  return (
    <section
      data-testid={DataTestIdEnum.CITY_SEARCH_SECTION_DEFAULT}
      className="flex bg-green-500 w-full pt-10 h-[436px] sm:h-auto overflow-hidden"
    >
      <ContentContainer className="flex flex-col xl:flex-row items-center justify-between xl:gap-10 relative">
        <div className="w-full 3xl:w-1/3">
          <SearchSectionTitle
            data-testid={DataTestIdEnum.CITY_SEARCH_SECTION_TITLE}
            className="sm:static sm:mb-2 absolute top-0 left-6"
          >
            O que você procura?
          </SearchSectionTitle>

          <SearchSectionSubtitle
            data-testid={DataTestIdEnum.CITY_SEARCH_SECTION_SUBTITLE}
            className="hidden md:block mr-0 md:mr-40 lg:mr-30 xl:mr-32 3xl:mr-0 mb-4"
          />

          <MedprevOnlineScheduleButton
            titleButton="Agendar agora"
            className="mt-4 hidden xl:flex"
            data-analytics-event={AnalyticsEnum.CLICK_SCHEDULE_NOW_HOME_PAGE}
            from="hero"
            sessionName="chamada_principal"
          />
        </div>

        <Image
          src={persons}
          alt="Colaboradores"
          height={370}
          draggable={false}
          className="hidden lg:block object-contain"
          priority
        />

        <div className="hidden md:flex lg:hidden w-full justify-end">
          <Image
            src={persons}
            alt="Colaboradores"
            height={360}
            draggable={false}
            className="-mx-24 object-contain"
            priority
          />
        </div>

        <div className="hidden sm:flex md:hidden w-full">
          <SearchSectionSubtitle className="sm:mr-20" />

          <Image
            src={onePerson}
            alt="Colaborador"
            priority
            fetchPriority="high"
            height={340}
            draggable={false}
            className="-mx-11 object-contain"
          />
        </div>

        <div className="flex flex-col sm:hidden w-full">
          <div className="absolute top-0">
            <SearchSectionSubtitle className="mt-10 mr-32 pre-mobile:mr-44" />
          </div>

          <div className="absolute bottom-0 right-0 flex items-end justify-end w-full">
            <Image
              src={onePersonMobile}
              alt="Colaborador"
              priority
              fetchPriority="high"
              height={330}
              draggable={false}
              className="object-contain"
            />
          </div>
        </div>

        <div className="block xl:hidden absolute bottom-0 left-0 w-full">
          <SearchSectionBoxButtons className="p-6 sm:px-16 md:px-6 lg:py-10">
            <MedprevOnlineScheduleButton
              titleButton="Agendar agora"
              data-analytics-event={AnalyticsEnum.CLICK_SCHEDULE_NOW_HOME_PAGE}
              from="hero"
              sessionName="chamada_principal"
            />
          </SearchSectionBoxButtons>
        </div>
      </ContentContainer>
    </section>
  );
};
